module.exports = __webpack_public_path__ + "assets/pinterest.dbf927dd.svg";